import { h, Component } from 'preact';
import { optoutTranslations } from './translations';
import { createTranslator } from '../../js/translator';
import {
  cleanAnalyticsStoredEventSending,
  sendCreativeOptoutTrack
} from '../../js/TrackAnalyticsHelper';

export interface OptOutMainPropsType {
  locale?: string;
  iconSize?: string | number;
  iconColor?: string;
  iconStyle?: h.JSX.CSSProperties;
  childPrivacyApplied?: boolean;
  isExpanded?: boolean;
  onClick?: () => any;
}

// should not be used directly
export default class OptOutMainComponent<
  T extends OptOutMainPropsType
> extends Component<T> {
  translate: Function = () => {};

  constructor(props: T, context: Object) {
    super(props, context);

    this.translate = this.props.locale
      ? createTranslator(this.props.locale, optoutTranslations)
      : () => '__error: no locale specified__';

    this.onClick = this.onClick.bind(this);
  }

  onClick(e: MouseEvent) {
    e.stopPropagation();
    cleanAnalyticsStoredEventSending();
    sendCreativeOptoutTrack();

    this.props.onClick?.();
  }

  render(): Object {
    return <div />;
  }
}
